import { Box, Typography } from "@mui/material";
import { getImageKey } from "./ticketFormHelpers";

// The "attach images" link and thumbnails of the attached images (click one to delete it)
const ImageAttachments = ({ formData, handleImageUpload, handleImageClick }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <input
      type="file"
      accept="image/*"
      multiple
      style={{ display: "none" }}
      id="image-upload"
      onChange={handleImageUpload}
    />
    <Typography
      variant="caption"
      sx={{ color: "text.secondary" }}
    >
      ככל ויש ברשותך תמונות של המכשיר התקול אנא צרף/י תמונות{" "}
      <label
        htmlFor="image-upload"
        style={{
          color: "#006699",
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        בקישור
      </label>
    </Typography>
    {formData.images.length > 0 && (
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", maxWidth: "300px" }}>
        {formData.images.map((image, index) => (
          <Box key={getImageKey(image)} sx={{ position: "relative" }} onClick={() => handleImageClick(index)}>
            <img
              src={URL.createObjectURL(image)}
              alt={`Uploaded ${index + 1}`}
              style={{
                width: 60,
                height: 60,
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          </Box>
        ))}
      </Box>
    )}
  </Box>
);

export default ImageAttachments;
